import styled from "@emotion/styled";

/**
 * ad card `height` structure:
 * - top blank area: (100vh - 178vw) / 2
 *                  |--- ad area in the top of "MORE" button: 178vw - 42px - 17.8vw
 * - ad area: 178vw |--- "MORE" button: 42px
 *                  |--- ad area in the bottom of "MORE" button: 17.8vw
 * - bottom blank area: (100vh - 178vw) / 2
 */

/**
 * The clickable area with calculated block-size need to use `position: absolute`
 * to avoid the clickable blocks the full-page ads "MORE" button on the devices with lower vertical viewport
 */
export const TopClickableArea = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  z-index: 1;

  inline-size: 100%;
  block-size: calc((100vh * (3 / 4)) + 42px);

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 80%;
  }
`;

export const BottomClickableArea = styled.div`
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;
  z-index: 1;

  inline-size: 100%;
  block-size: calc(17.8vw + ((100vh * (3 / 4) - 178vw) / 2));

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 5%;
  }
`;

export const LeftClickableArea = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  z-index: 2;

  inline-size: 25%;
  block-size: 100%;
`;

export const RightClickableArea = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  z-index: 1;

  inline-size: 35%;
  block-size: 100%;
`;
